"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const Board_vue_1 = __importDefault(require("~components/Board.vue"));
const TopMenu_vue_1 = __importDefault(require("~components/TopMenu.vue"));
const store_1 = require("~/front/store");
const Piece_1 = require("~/chess/Piece");
let Game = class Game extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.game = store_1.store.state.game;
        this.notifications = store_1.store.state.notifications;
    }
    onGameChange() {
        if (this.game.isCheck !== false) {
            if (this.game.isCheckMate !== false) {
                this.$notify({
                    title: 'Check mate',
                    text: `Check mate. ${Piece_1.Color[this.game.oppositeTurn]} wins the game.`
                });
            }
            else {
                this.$notify({
                    title: 'Check',
                    text: `The ${Piece_1.Color[this.game.isCheck]} king is in check.`
                });
            }
        }
    }
    onNewNotification() {
        this.$notify({
            title: 'Error',
            text: this.notifications[this.notifications.length - 1]
        });
    }
};
__decorate([
    vue_property_decorator_1.Watch('game')
], Game.prototype, "onGameChange", null);
__decorate([
    vue_property_decorator_1.Watch('notifications')
], Game.prototype, "onNewNotification", null);
Game = __decorate([
    vue_property_decorator_1.Component({
        components: {
            Board: Board_vue_1.default,
            TopMenu: TopMenu_vue_1.default
        }
    })
], Game);
exports.default = Game;
